import { useTranslation } from "react-i18next";

export default function WhatsAppButton() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith("ar");
  const phoneNumber = "966532785554";
  const message = isRTL
    ? "مرحباً، أنا مهتم بحلول التخزين من ابراج الرفوف."
    : "Hello, I am interested in storage solutions from Arafouf.";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 z-40 flex items-center gap-2 bg-[#25D366] text-white font-medium px-4 py-3 rounded-full shadow-lg hover:bg-[#128C7E] transition-colors cursor-pointer whitespace-nowrap ${
        isRTL ? "left-6" : "right-6"
      }`}
      aria-label="WhatsApp"
    >
      <span className="w-6 h-6 flex items-center justify-center">
        <i className="ri-whatsapp-line text-xl" />
      </span>
      <span className="text-sm">{isRTL ? "تواصل معنا" : "Contact Us"}</span>
    </a>
  );
}